<template>
  <div class="main-otc">
    <div class="layer">
      <div class="right-otc-section">

        <div class="type">
          <span class="title-1">نگاه کلی به بازار</span>
          <div class="buttons">
            <button @click="select ='crypto'" class="solid-gray-btn" :class="{'gray-btn' : select === 'crypto'}">
              رمز ارز
            </button>

            <button @click="select = 'gold'" class="solid-gray-btn" :class="{'gray-btn' : select === 'gold'}">
              طلا و سکه
            </button>
          </div>
        </div>

        <div class="sort">
          <span class="title-2">مرتب سازی بر اساس</span>
          <div class="buttons">
            <div class="right-area">
              <button @click="topvaluefn" :class="{'gray-btn' : sort == 'topvalue'}"
                      class="solid-gray-btn solid-gray-btn-custom-2">بالاترین حجم معاملات
              </button>
              <button @click="toppricefn" :class="{'gray-btn' : sort == 'topprice'}"
                      class="solid-gray-btn solid-gray-btn-custom-2">بالاترین افزایش قیمت
              </button>
            </div>

            <div class="left-area">

              <button @click="usdtFn" class="solid-gray-btn btn" :class="{'gray-btn' : type === 'TETHER'}">
                USDT | تتر
              </button>

              <button @click="tomanFn" class="solid-gray-btn btn" :class="{'gray-btn' : type === 'TOMAN'}">
                TMN | تومان
              </button>

            </div>
          </div>
        </div>

        <div class="table">
          <table>
            <tr>
              <th class="first">ارز</th>
              <th class="center none">قیمت لحظه ایی</th>
              <th class="center"> تغییرات <small>(24h)</small></th>
              <th class="last"> حجم <small>(24h)</small></th>
            </tr>

            <template v-if="$store.state.type=='toman'">
              <tr v-for="(item , index) in $store.state.market.slice(0,8)" :key="index">
                <td>
                  <div class="name-coin">

                    <img class="hide992" :src="require('@/assets/coins/'+$coinsUnit[item.relatedCoin.toUpperCase()]+'.svg')" alt="item.relatedCoin">

                    <div class="name">
                      <p class="p-name">{{ $coinLabel[item.relatedCoin] }}</p>
                      <small class="relate-coin hide992">{{ $coinsUnit[item.relatedCoin.toUpperCase()] }}</small>
                    </div>
                  </div>
                </td>

                <td class="center" >{{ $toLocal(item.lastPrice, $decimal['TOMAN']) }}</td>
                <td class="hide992 number center" :class="{'red':item.last24HourChange <= 0 , 'green':item.last24HourChange > 0}">
                  {{ $toPrecision(item.last24HourChange,2) + '%' }}
                </td>
                <td class="hide400 last" >{{ $toLocal(item.last24HourVolume, $decimal['TOMAN']) }}</td>


              </tr>
            </template>

            <template v-if="$store.state.type=='usdt'">
              <tr v-for="(item , index) in $store.state.marketUSDT.slice(0,8)" :key="index">
                <td>
                  <div class="name-coin">

                    <img class="hide992" :src="require('@/assets/coins/'+$coinsUnit[item.relatedCoin.toUpperCase()]+'.svg')" alt="item.relatedCoin">

                    <div class="name">
                      <p class="p-name">{{ $coinLabel[item.relatedCoin] }}</p>
                      <small class="relate-coin hide992">{{ $coinsUnit[item.relatedCoin.toUpperCase()] }}</small>
                    </div>
                  </div>
                </td>

                <td class="center" >{{ $toLocal(item.lastPrice, $decimal[item.relatedCoin]) }}</td>
                <td class="hide992 number center" :class="{'red':item.last24HourChange <= 0 , 'green':item.last24HourChange > 0}">
                  {{ $toLocal(item.last24HourChange,2) + '%' }}
                </td>
                <td class="hide400 last" >{{ $toLocal(item.last24HourVolume, $decimal['TOMAN']) }}</td>


              </tr>
            </template>

















<!--            <tr class="tr-class" v-for="(item , index) in dataTable.slice(0,5)" :key="index">-->
<!--              <td class="first">-->
<!--                <div class="name-coin">-->
<!--                  <inline-svg class="hide992" :src="require('../assets/coins/'+item.logo+'.svg')"/>-->
<!--                  <div class="name">-->
<!--                    <p class="p-name">{{ item.name }}</p>-->
<!--                    <small class="relate-coin hide992">{{ item.relatedCoin }}</small>-->
<!--                  </div>-->
<!--                </div>-->

<!--              </td>-->
<!--              <td class="center none">{{ item.price }}</td>-->
<!--              <td class="hide992 center number" :class="{'red':item.lastChange > 0 , 'green':item.lastChange < 0}">-->
<!--                {{ item.lastChange + ' ' +'%'}}-->
<!--              </td>-->
<!--              <td class="hide400 last">{{ item.value }}</td>-->
<!--            </tr>-->
          </table>
        </div>
      </div>

      <div class="left-otc-section">
        <h3>OTC - معامله سریع</h3>
        <the-otc/>
      </div>
    </div>
  </div>
</template>

<script>
import TheOtc from "./tools/otc";
export default {
  name: "OTC",
  components: {TheOtc},
  data() {
    return {
      select: 'crypto',
      sort: 'topvalue',
      type: 'TOMAN',
      tableTether:[],
      tableData: [],
      tableToman:[],
      //data table
      dataTable: [
        {name: 'بیت کوین', price: 123456789, relatedCoin: 'BTC', logo: 'BTC', lastChange: '+3.2', value: 12352648},
        {name: 'دوج کوین', price: 123456789, relatedCoin: 'DOGE', logo: 'DOGE', lastChange: '-3.2', value: 12352648},
        {name: 'بایننس کوین', price: 123456789, relatedCoin: 'BNB', logo: 'BNB', lastChange: '+3.2', value: 12352648},
        {name: 'اتریوم', price: 123456789, relatedCoin: 'ETH', logo: 'ETH', lastChange: '-3.2', value: 12352648},
        {name: 'بیت کوین کش', price: 123456789, relatedCoin: 'BCH', logo: 'BCH', lastChange: '+3.2', value: 12352648},
        {name: 'استلار', price: 123456789, relatedCoin: 'XLM', logo: 'XLM', lastChange: '-3.2', value: 12352648},
        {name: 'ریپل', price: 123456789, relatedCoin: 'XPR', logo: 'XPR', lastChange: '-3.2', value: 12352648},
        {name: 'ترون', price: 123456789, relatedCoin: 'TRON', logo: 'TRON', lastChange: '+3.2', value: 12352648},
        {name: 'سلو', price: 123456789, relatedCoin: 'CELO', logo: 'CELO', lastChange: '-3.2', value: 12352648},
        {name: 'لایت کوین', price: 123456789, relatedCoin: 'LTC', logo: 'LTC', lastChange: '+3.2', value: 12352648},
        {name: 'ماتیک', price: 123456789, relatedCoin: 'MATIC', logo: 'MATIC', lastChange: '-3.2', value: 12352648},
        {name: 'تتر', price: 123456789, relatedCoin: 'USDT', logo: 'USDT', lastChange: '-3.2', value: 12352648},
      ]
    }
  },

  watch: {
    'setcoins'() {
      let usd;
      let usdt
      usd = this.$store.state.market
      usdt = this.$store.state.marketUSDT
      this.tableToman = usd
      this.tableTether = usdt
      this.show = true;

      this.state.loading = false;

    },
  },



  methods: {
    topvaluefn() {
      this.sort = 'topvalue'
      let data = this.$store.state.market;
      let dataUSDT = this.$store.state.marketUSDT
      let gold = this.GoldDataTable
      data.sort((a, b) => b.last24HourChange - a.last24HourChange);
      dataUSDT.sort((a, b) => b.last24HourChange - a.last24HourChange);
      gold.sort((a, b) => b.last24HourChange - a.last24HourChange);
      this.tableToman = data;
      this.goldData = gold;
      this.tableTether = dataUSDT;

    },

    toppricefn() {
      this.sort = 'topprice'
      let data = this.$store.state.market;
      let gold = this.GoldDataTable
      let dataUSDT = this.$store.state.marketUSDT
      data.sort((a, b) => b.lastPrice - a.lastPrice);
      dataUSDT.sort((a, b) => b.lastPrice - a.lastPrice);
      // data.sort((a, b) => b.lastPrice - a.lastPrice);
      gold.sort((a, b) => b.lastPrice - a.lastPrice);
      // gold.sort((a, b) => b.lastPrice - a.lastPrice);
      this.tableToman = data;
      this.goldData = gold;
      this.tableTether = dataUSDT;

    },

    usdtFn() {
      this.type = 'TETHER'
      this.$store.commit('changeType' , 'usdt')
      console.log(this.$store.state.type)

    },

    tomanFn() {
      this.type = 'TOMAN'
      this.$store.commit('changeType' , 'toman')
      console.log(this.$store.state.type)

    },
    setTables() {
      this.tableToman = this.$store.state.market;
      this.tableTether = this.$store.state.marketUSDT;
    },
    mounted() {
      this.setTables()
      this.topvaluefn()
      this.state.loading =true;

    }
  }
}
</script>

<style lang="scss" scoped>
.gray-btn {
  background: rgba(215, 200, 200, 0.12) !important;
  border-radius: 4px !important;
  color: rgba(17, 153, 250, 1) !important;
  cursor: pointer !important;
  font-size: clamp(10px, 2vw, 12px) !important;
  height: auto;
  width: auto;
}

.main-otc {
  background-image: url("../assets/backgrounds/otc.png");
  background-position: center;
  background-size: cover;
  direction: rtl;
  display: flex;
  justify-content: center;
  align-items: center;

  .layer {
    display: flex;
    flex-direction: row;
    width: 90%;
    gap: 50px;
    flex-wrap: wrap;
    margin-bottom: 40px;


    .right-otc-section {
      flex-grow: 2;
      flex-basis: 200px;
      display: flex;
      flex-direction: column;
      gap: 36px;

      .type {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        flex-wrap: wrap;
        gap: 40px;
        margin-top: 36px;

        .buttons {
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          gap: 20px;
        }

        button {
          width: 92px;
          height: 32px;
          margin-left: 16px;
        }

        .title-1 {
          font-size: clamp(14px, 2vw, 16px);
          font-weight: bold;
          color: #FBFBFD;
        }
      }

      .sort {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        flex-wrap: wrap;

        .right-area {
          display: flex;
          flex-direction: row;
          gap: 20px;
          flex-wrap: wrap;
        }

        .left-area {
          display: flex;
          flex-direction: row;
          gap: 20px;
          flex-wrap: wrap;
        }

        .title-2 {
          font-size: clamp(12px, 2vw, 16px);
          font-weight: bold;
          color: #D7C8C8;
          width: 20%;
          flex-basis: 150px;
          margin-bottom: 20px;
          text-align: right;
        }

        .buttons {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          flex-wrap: wrap;
          gap: 20px;
          width: 80%;

          .btn {
            width: 92px;
            height: 32px;
          }
        }

        button {
          width: 140px;
          height: 32px;
        }
      }

      .table {
        flex-grow: 1;
        color: #FFFFFF;
        font-size: clamp(12px , 0.7vw , 16px);

        .first {
          text-align: right;
        }

        .last {
          text-align: left;
        }

        .center {
          text-align: center;
        }

        table {
          tr {
            height: 35px;

            &:hover {
              cursor: pointer;
              background: linear-gradient(259.33deg, rgba(28, 52, 102, 0) 7.64%, rgba(28, 52, 102, 0.35) 52.12%, rgba(20, 37, 69, 0.24) 83.62%);
            }
          }
        }

        .name-coin {
          display: flex;
          flex-direction: row;
          gap: 10px;
          align-items: center;

          img {
            width: 30px;
          }

          .name {
            display: flex;
            flex-direction: column;
            gap: 0;


            .p-name {
              font-size: clamp(12px, 2vw, 16px);
              color: #FBFBFD;
            }

            .relate-coin {
              font-size: clamp(8px, 2vw, 10px);
              color: rgba(215, 200, 200, 1);
            }
          }
        }

        .chart-td {
          width: 70%;
          height: 42px;
        }

        .svg {
          position: absolute;
          width: 0 !important;
          height: 0 !important;
        }

        .btn-td {
          text-align: end;
        }

        .btn-th {
          display: flex;
          gap: 10px;
          justify-content: end;
        }

        .gray-btn-custom-3 {
          width: 92px;
          height: 32px
        }

        .solid-gray-btn-custom-3 {
          width: 92px;
          height: 32px
        }

        .custom-blue-btn {
          width: 121px;
          height: 37px
        }
      }
    }

    .left-otc-section {
      flex-grow: 1;
      flex-basis: 100px;

      h3{
        text-align: left;
        color: #FFFFFF;
        margin: 40px 0;
      }
    }
  }
}

@media (max-width: 600px) {
  .name-coin svg{
    display: none !important;
  }

  .none{
    display: none;
  }

  .layer{
    flex-direction: column !important;
  }
}
</style>